export default __webpack_public_path__ + "static/RPA-bbad607936b1e4ee0e11ce3ba06eede9.webp";